<template>
	<div>
		<Head :title="product.name" />

		<Breadcrumbs
			href="/products"
			:parentLabel="__('Products')"
			:childLabel="product.name"
			:directLink="directLink(product)"
		/>
		<TrashedMessage v-if="product.deleted_at" class="mb-6">
			{{ __('This product has been deleted.') }}
		</TrashedMessage>

		<div class="max-w-full overflow-hidden bg-white rounded-md shadow">
			<ProductForm :submit="update" :model="product" label="Update Product" />
		</div>
	</div>
</template>

<script>
	import { Head } 	  from '@inertiajs/inertia-vue3'
	import Layout 		  from '@/Shared/Layout'
	import TrashedMessage from '@/Shared/TrashedMessage'
	import Breadcrumbs 	  from '@/Shared/Breadcrumbs'
	import ProductForm 	  from './Form'

	export default {
		components: {
			Head,
			Breadcrumbs,
			TrashedMessage,
			ProductForm,
		},
		layout: Layout,
		props: {
			product: Object,
		},
		data() {
			return {}
		},
		methods: {
			update(form) {
				form.post(`/products/${this.product.id}`, {
                    // _method: 'patch',
                    forceFormData: true,
                    // preserveScroll: true
                })
			},
			directLink(product) {

				// Create a nifty URL for the product
				let productName = product.name
					.replace(/\s+/g, '-')
					.replace(/[áàäâãåÁÀÄÂÃÅ]/g, 'a')
					.replace(/[óòöôõÓÒÖÔÕ]/g, 'o')
					.replace(/[éèëêÉÈËÊ]/g, 'e')
					.replace(/[úùüûÚÙÜÛ]/g, 'u')
					.replace(/[íìïîÍÌÏÎ]/g, 'i')
					.replace(/[^a-zA-Z0-9-]/g, '')
					.toLowerCase();

				return product.categories_ids.includes(1) ? `https://www.eliquis.se/material/${product.id}-${productName}` : ''
			},
		}
	}
</script>
